import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  invalidTrailingComma2uwwnmbqspks2 as invalidTrailingComma,
  minify1kh64osmcox7j as minify,
  access$formatDecodingException$tJsonExceptionsKt2yfifxvnjk03f as access$formatDecodingException$tJsonExceptionsKt,
  throwInvalidFloatingPointDecoded3ghwdo6vya1kj as throwInvalidFloatingPointDecoded,
} from './JsonExceptions.mjs';
import {
  getJsonNameIndex1fee1p51fy8fj as getJsonNameIndex,
  ignoreUnknownKeys1ot1okvsp9ttf as ignoreUnknownKeys,
  getJsonNameIndexOrThrow1a6a29i1xie0m as getJsonNameIndexOrThrow,
} from './JsonNamesMap.mjs';
import { ENUM_getInstance3ph4fa6o285vr as ENUM_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { AbstractDecoder35guh02ubh2hm as AbstractDecoder } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/AbstractDecoder.mjs';
import { JsonElementMarker395jk2pil4789 as JsonElementMarker } from './JsonElementMarker.mjs';
import { JsonTreeReader1ycreu77eikqj as JsonTreeReader } from './JsonTreeReader.mjs';
import { AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/AbstractPolymorphicSerializer.mjs';
import { classDiscriminator9fd3hvqsgfqq as classDiscriminator } from './Polymorphic.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { DeserializationStrategy1z3z5pj9f7zc8 as DeserializationStrategy } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  JsonObjectee06ihoeeiqj as JsonObject,
  get_jsonPrimitivez17tyd5rw1ql as get_jsonPrimitive,
  get_contentOrNull35s97cgi8z9eo as get_contentOrNull,
} from '../JsonElement.mjs';
import {
  getKClass3t8tygqu4lcxf as getKClass,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { JsonDecodingExceptionoyag1psadwuw as JsonDecodingException } from '../JsonExceptions.mjs';
import { findPolymorphicSerializer1nm87hvemahcj as findPolymorphicSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/PolymorphicSerializer.mjs';
import {
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
  MissingFieldException24tqif29emcmi as MissingFieldException,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { readPolymorphicJson7wfdzotvo8aj as readPolymorphicJson } from './TreeJsonDecoder.mjs';
import {
  substringBefore3n7kj60w69hju as substringBefore,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  substringAfter1hku067gwr5ve as substringAfter,
  contains3ue2qo8xhmpf1 as contains,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { plus17rl43at52ays as plus } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { missingFieldExceptionWithNewMessage2gqddjx5jxge9 as missingFieldExceptionWithNewMessage } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/JsonInternalDependencies.mjs';
import {
  switchMode35g725ikhjpwv as switchMode,
  WriteMode_MAP_getInstancecqiyv70l0phh as WriteMode_MAP_getInstance,
} from './WriteMode.mjs';
import {
  convertToByte2t4hntblnhq2k as convertToByte,
  fromInt2ii0rejb1w62w as fromInt,
  convertToShortn6n5n7ruahkm as convertToShort,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { toDouble1kn912gjoizjp as toDouble } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  isFinite1tx0gn65nl9tj as isFinite,
  isFinite2t9l5a275mxm6 as isFinite_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/NumbersJs.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { get_isUnsignedNumber3dxwaa3af8ncr as get_isUnsignedNumber } from './StreamingJsonEncoder.mjs';
import { JsonDecoder1rijst5ne6qla as JsonDecoder } from '../JsonDecoder.mjs';
import {
  toUInt21lx0mz8wkp7c as toUInt,
  toULong266mnyksbttkw as toULong,
  toUByteh6p4wmqswkrs as toUByte,
  toUShort7yqspfnhrot4 as toUShort,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/UStrings.mjs';
import { _UInt___get_data__impl__f0vqqw2j5mttix8w0l0 as _UInt___get_data__impl__f0vqqw } from '../../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import { _ULong___get_data__impl__fggpzb2bbucljk081qt as _ULong___get_data__impl__fggpzb } from '../../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import { _UByte___get_data__impl__jof9qr23gcv767stjfh as _UByte___get_data__impl__jof9qr } from '../../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import { _UShort___get_data__impl__g0245313795p1x5hw5 as _UShort___get_data__impl__g0245 } from '../../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DiscriminatorHolderClass;
function DiscriminatorHolder() {
  if (DiscriminatorHolderClass === VOID) {
    class $ {
      constructor(discriminatorToSkip) {
        this.g2u_1 = discriminatorToSkip;
      }
    }
    initMetadataForClass($, 'DiscriminatorHolder');
    DiscriminatorHolderClass = $;
  }
  return DiscriminatorHolderClass;
}
function trySkip($this, $receiver, unknownKey) {
  if ($receiver == null)
    return false;
  if ($receiver.g2u_1 === unknownKey) {
    $receiver.g2u_1 = null;
    return true;
  }
  return false;
}
function skipLeftoverElements($this, descriptor) {
  while (!($this.a1s(descriptor) === -1)) {
  }
}
function checkLeadingComma($this) {
  if ($this.s2m_1.v2t() === 4) {
    $this.s2m_1.p2s('Unexpected leading comma');
  }
}
function decodeMapIndex($this) {
  var hasComma = false;
  var decodingKey = !(($this.u2m_1 % 2 | 0) === 0);
  if (decodingKey) {
    if (!($this.u2m_1 === -1)) {
      hasComma = $this.s2m_1.i2u();
    }
  } else {
    $this.s2m_1.h2u(_Char___init__impl__6a9atx(58));
  }
  var tmp;
  if ($this.s2m_1.w2t()) {
    if (decodingKey) {
      if ($this.u2m_1 === -1) {
        var tmp0 = $this.s2m_1;
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
        var condition = !hasComma;
        var position = tmp0.z2m_1;
        if (!condition) {
          var tmp$ret$1 = 'Unexpected leading comma';
          tmp0.p2s(tmp$ret$1, position);
        }
      } else {
        var tmp0_0 = $this.s2m_1;
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
        var condition_0 = hasComma;
        var position_0 = tmp0_0.z2m_1;
        if (!condition_0) {
          var tmp$ret$3 = 'Expected comma after the key-value pair';
          tmp0_0.p2s(tmp$ret$3, position_0);
        }
      }
    }
    $this.u2m_1 = $this.u2m_1 + 1 | 0;
    tmp = $this.u2m_1;
  } else {
    if (hasComma && !$this.q2m_1.l2m_1.m2o_1) {
      invalidTrailingComma($this.s2m_1);
    }
    tmp = -1;
  }
  return tmp;
}
function coerceInputValue($this, descriptor, index) {
  var tmp0 = $this.q2m_1;
  var tmp$ret$0;
  $l$block_2: {
    // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
    var isOptional = descriptor.w1p(index);
    var elementDescriptor = descriptor.v1p(index);
    var tmp;
    if (isOptional && !elementDescriptor.h1p()) {
      tmp = $this.s2m_1.j2u(true);
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_2;
    }
    if (equals(elementDescriptor.o1p(), ENUM_getInstance())) {
      var tmp_0;
      if (elementDescriptor.h1p()) {
        tmp_0 = $this.s2m_1.j2u(false);
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = false;
        break $l$block_2;
      }
      var tmp0_elvis_lhs = $this.s2m_1.k2u($this.w2m_1.a2o_1);
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$0 = false;
        break $l$block_2;
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      var enumValue = tmp_1;
      var enumIndex = getJsonNameIndex(elementDescriptor, tmp0, enumValue);
      var coerceToNull = !tmp0.l2m_1.d2o_1 && elementDescriptor.h1p();
      if (enumIndex === -3 && (isOptional || coerceToNull)) {
        $this.s2m_1.x2t();
        tmp$ret$0 = true;
        break $l$block_2;
      }
    }
    tmp$ret$0 = false;
  }
  return tmp$ret$0;
}
function decodeObjectIndex($this, descriptor) {
  var hasComma = $this.s2m_1.i2u();
  while ($this.s2m_1.w2t()) {
    hasComma = false;
    var key = decodeStringKey($this);
    $this.s2m_1.h2u(_Char___init__impl__6a9atx(58));
    var index = getJsonNameIndex(descriptor, $this.q2m_1, key);
    var tmp;
    if (!(index === -3)) {
      var tmp_0;
      if ($this.w2m_1.f2o_1 && coerceInputValue($this, descriptor, index)) {
        hasComma = $this.s2m_1.i2u();
        tmp_0 = false;
      } else {
        var tmp0_safe_receiver = $this.x2m_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.m2s(index);
        }
        return index;
      }
      tmp = tmp_0;
    } else {
      tmp = true;
    }
    var isUnknown = tmp;
    if (isUnknown) {
      hasComma = handleUnknown($this, descriptor, key);
    }
  }
  if (hasComma && !$this.q2m_1.l2m_1.m2o_1) {
    invalidTrailingComma($this.s2m_1);
  }
  var tmp1_safe_receiver = $this.x2m_1;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.n2s();
  return tmp2_elvis_lhs == null ? -1 : tmp2_elvis_lhs;
}
function handleUnknown($this, descriptor, key) {
  if (ignoreUnknownKeys(descriptor, $this.q2m_1) || trySkip($this, $this.v2m_1, key)) {
    $this.s2m_1.m2u($this.w2m_1.a2o_1);
  } else {
    $this.s2m_1.a2n_1.c2t();
    $this.s2m_1.l2u(key);
  }
  return $this.s2m_1.i2u();
}
function decodeListIndex($this) {
  var hasComma = $this.s2m_1.i2u();
  var tmp;
  if ($this.s2m_1.w2t()) {
    if (!($this.u2m_1 === -1) && !hasComma) {
      $this.s2m_1.p2s('Expected end of the array or comma');
    }
    $this.u2m_1 = $this.u2m_1 + 1 | 0;
    tmp = $this.u2m_1;
  } else {
    if (hasComma && !$this.q2m_1.l2m_1.m2o_1) {
      invalidTrailingComma($this.s2m_1, 'array');
    }
    tmp = -1;
  }
  return tmp;
}
function decodeStringKey($this) {
  var tmp;
  if ($this.w2m_1.a2o_1) {
    tmp = $this.s2m_1.o2u();
  } else {
    tmp = $this.s2m_1.n2u();
  }
  return tmp;
}
var StreamingJsonDecoderClass;
function StreamingJsonDecoder() {
  if (StreamingJsonDecoderClass === VOID) {
    class $ extends AbstractDecoder() {
      constructor(json, mode, lexer, descriptor, discriminatorHolder) {
        super();
        this.q2m_1 = json;
        this.r2m_1 = mode;
        this.s2m_1 = lexer;
        this.t2m_1 = this.q2m_1.y1r();
        this.u2m_1 = -1;
        this.v2m_1 = discriminatorHolder;
        this.w2m_1 = this.q2m_1.l2m_1;
        this.x2m_1 = this.w2m_1.d2o_1 ? null : new (JsonElementMarker())(descriptor);
      }
      q2o() {
        return this.q2m_1;
      }
      y1r() {
        return this.t2m_1;
      }
      r2o() {
        return (new (JsonTreeReader())(this.q2m_1.l2m_1, this.s2m_1)).z2t();
      }
      i1r(deserializer) {
        try {
          var tmp;
          if (!(deserializer instanceof AbstractPolymorphicSerializer())) {
            tmp = true;
          } else {
            tmp = this.q2m_1.l2m_1.g2o_1;
          }
          if (tmp) {
            return deserializer.u1m(this);
          }
          var discriminator = classDiscriminator(deserializer.s1m(), this.q2m_1);
          var tmp0_elvis_lhs = this.s2m_1.p2u(discriminator, this.w2m_1.a2o_1);
          var tmp_0;
          if (tmp0_elvis_lhs == null) {
            var tmp2 = isInterface(deserializer, DeserializationStrategy()) ? deserializer : THROW_CCE();
            var tmp$ret$0;
            $l$block: {
              // Inline function 'kotlinx.serialization.json.internal.decodeSerializableValuePolymorphic' call
              var tmp_1;
              if (!(tmp2 instanceof AbstractPolymorphicSerializer())) {
                tmp_1 = true;
              } else {
                tmp_1 = this.q2o().l2m_1.g2o_1;
              }
              if (tmp_1) {
                tmp$ret$0 = tmp2.u1m(this);
                break $l$block;
              }
              var discriminator_0 = classDiscriminator(tmp2.s1m(), this.q2o());
              var tmp2_0 = this.r2o();
              // Inline function 'kotlinx.serialization.json.internal.cast' call
              var serialName = tmp2.s1m().v1n();
              if (!(tmp2_0 instanceof JsonObject())) {
                var tmp2_1 = 'Expected ' + getKClass(JsonObject()).j1() + ', but had ' + getKClassFromExpression(tmp2_0).j1() + ' as the serialized body of ' + serialName;
                // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
                var path = this.s2m_1.a2n_1.d2t();
                var tmp_2;
                if (this.q2o().l2m_1.p2o_1) {
                  var tmp$ret$6 = toString(tmp2_0);
                  tmp_2 = toString(minify(tmp$ret$6));
                } else {
                  tmp_2 = null;
                }
                var inputValue = tmp_2;
                throw JsonDecodingException().d2q(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_1, path, null, inputValue), tmp2_1, -1, path, inputValue, null);
              }
              var jsonTree = tmp2_0;
              var tmp0_safe_receiver = jsonTree.v2o(discriminator_0);
              var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
              var type = tmp1_safe_receiver == null ? null : get_contentOrNull(tmp1_safe_receiver);
              var tmp_3;
              try {
                tmp_3 = findPolymorphicSerializer(tmp2, this, type);
              } catch ($p) {
                var tmp_4;
                if ($p instanceof SerializationException()) {
                  var it = $p;
                  // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
                  var shortMessage = ensureNotNull(it.message);
                  var tmp_5;
                  if (this.q2o().l2m_1.p2o_1) {
                    var tmp$ret$10 = jsonTree.toString();
                    tmp_5 = toString(minify(tmp$ret$10));
                  } else {
                    tmp_5 = null;
                  }
                  var inputValue_0 = tmp_5;
                  throw JsonDecodingException().d2q(access$formatDecodingException$tJsonExceptionsKt(-1, shortMessage, null, null, inputValue_0), shortMessage, -1, null, inputValue_0, null);
                } else {
                  throw $p;
                }
              }
              var tmp_6 = tmp_3;
              var actualSerializer = isInterface(tmp_6, DeserializationStrategy()) ? tmp_6 : THROW_CCE();
              tmp$ret$0 = readPolymorphicJson(this.q2o(), discriminator_0, jsonTree, actualSerializer);
            }
            return tmp$ret$0;
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }
          var type_0 = tmp_0;
          var tmp_7;
          try {
            tmp_7 = findPolymorphicSerializer(deserializer, this, type_0);
          } catch ($p) {
            var tmp_8;
            if ($p instanceof SerializationException()) {
              var it_0 = $p;
              var message = removeSuffix(substringBefore(ensureNotNull(it_0.message), _Char___init__impl__6a9atx(10)), '.');
              var hint = substringAfter(ensureNotNull(it_0.message), _Char___init__impl__6a9atx(10), '');
              this.s2m_1.p2s(message, VOID, hint);
            } else {
              throw $p;
            }
            tmp_7 = tmp_8;
          }
          var tmp_9 = tmp_7;
          var actualSerializer_0 = isInterface(tmp_9, DeserializationStrategy()) ? tmp_9 : THROW_CCE();
          this.v2m_1 = new (DiscriminatorHolder())(discriminator);
          return actualSerializer_0.u1m(this);
        } catch ($p) {
          if ($p instanceof MissingFieldException()) {
            var e = $p;
            if (contains(ensureNotNull(e.message), 'at path'))
              throw e;
            throw missingFieldExceptionWithNewMessage(e, plus(e.message, ' at path: ') + this.s2m_1.a2n_1.d2t());
          } else {
            throw $p;
          }
        }
      }
      j1r(descriptor) {
        var newMode = switchMode(this.q2m_1, descriptor);
        this.s2m_1.a2n_1.y2s(descriptor);
        this.s2m_1.h2u(newMode.s2u_1);
        checkLeadingComma(this);
        var tmp;
        switch (newMode.w1_1) {
          case 1:
          case 2:
          case 3:
            tmp = new (StreamingJsonDecoder())(this.q2m_1, newMode, this.s2m_1, descriptor, this.v2m_1);
            break;
          default:
            var tmp_0;
            if (this.r2m_1.equals(newMode) && this.q2m_1.l2m_1.d2o_1) {
              tmp_0 = this;
            } else {
              tmp_0 = new (StreamingJsonDecoder())(this.q2m_1, newMode, this.s2m_1, descriptor, this.v2m_1);
            }

            tmp = tmp_0;
            break;
        }
        return tmp;
      }
      k1r(descriptor) {
        if (descriptor.q1p() === 0 && ignoreUnknownKeys(descriptor, this.q2m_1)) {
          skipLeftoverElements(this, descriptor);
        }
        if (this.s2m_1.i2u() && !this.q2m_1.l2m_1.m2o_1) {
          invalidTrailingComma(this.s2m_1, '');
        }
        this.s2m_1.h2u(this.r2m_1.t2u_1);
        this.s2m_1.a2n_1.c2t();
      }
      u1q() {
        var tmp;
        var tmp0_safe_receiver = this.x2m_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.l2s_1;
        if (!(tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs)) {
          tmp = !this.s2m_1.u2u();
        } else {
          tmp = false;
        }
        return tmp;
      }
      v1q() {
        return null;
      }
      v1r(descriptor, index, deserializer, previousValue) {
        var isMapKey = this.r2m_1.equals(WriteMode_MAP_getInstance()) && (index & 1) === 0;
        if (isMapKey) {
          this.s2m_1.a2n_1.b2t();
        }
        var value = super.v1r(descriptor, index, deserializer, previousValue);
        if (isMapKey) {
          this.s2m_1.a2n_1.a2t(value);
        }
        return value;
      }
      a1s(descriptor) {
        var index;
        switch (this.r2m_1.w1_1) {
          case 0:
            index = decodeObjectIndex(this, descriptor);
            break;
          case 2:
            index = decodeMapIndex(this);
            break;
          default:
            index = decodeListIndex(this);
            break;
        }
        if (!this.r2m_1.equals(WriteMode_MAP_getInstance())) {
          this.s2m_1.a2n_1.z2s(index);
        }
        return index;
      }
      w1q() {
        return this.s2m_1.v2u();
      }
      x1q() {
        var value = this.s2m_1.w2u();
        if (!(value === fromInt(convertToByte(value)))) {
          this.s2m_1.p2s("Failed to parse byte for input '" + value.toString() + "'");
        }
        return convertToByte(value);
      }
      y1q() {
        var value = this.s2m_1.w2u();
        if (!(value === fromInt(convertToShort(value)))) {
          this.s2m_1.p2s("Failed to parse short for input '" + value.toString() + "'");
        }
        return convertToShort(value);
      }
      z1q() {
        var value = this.s2m_1.w2u();
        if (!(value === fromInt(convertToInt(value)))) {
          this.s2m_1.p2s("Failed to parse int for input '" + value.toString() + "'");
        }
        return convertToInt(value);
      }
      a1r() {
        return this.s2m_1.w2u();
      }
      b1r() {
        var tmp0 = this.s2m_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.y2t();
          try {
            // Inline function 'kotlin.text.toFloat' call
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp$ret$0 = toDouble(input);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.p2s("Failed to parse type '" + 'float' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        var result = tmp$ret$0;
        var specialFp = this.q2m_1.l2m_1.i2o_1;
        if (specialFp || isFinite(result))
          return result;
        throwInvalidFloatingPointDecoded(this.s2m_1, result);
      }
      c1r() {
        var tmp0 = this.s2m_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.y2t();
          try {
            tmp$ret$0 = toDouble(input);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.p2s("Failed to parse type '" + 'double' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        var result = tmp$ret$0;
        var specialFp = this.q2m_1.l2m_1.i2o_1;
        if (specialFp || isFinite_0(result))
          return result;
        throwInvalidFloatingPointDecoded(this.s2m_1, result);
      }
      d1r() {
        var string = this.s2m_1.y2t();
        if (!(string.length === 1)) {
          this.s2m_1.p2s("Expected single char, but got '" + string + "'");
        }
        return charCodeAt(string, 0);
      }
      e1r() {
        var tmp;
        if (this.w2m_1.a2o_1) {
          tmp = this.s2m_1.o2u();
        } else {
          tmp = this.s2m_1.x2t();
        }
        return tmp;
      }
      g1r(descriptor) {
        return get_isUnsignedNumber(descriptor) ? new (JsonDecoderForUnsignedTypes())(this.s2m_1, this.q2m_1) : super.g1r(descriptor);
      }
      f1r(enumDescriptor) {
        return getJsonNameIndexOrThrow(enumDescriptor, this.q2m_1, this.e1r(), ' at path ' + this.s2m_1.a2n_1.d2t());
      }
    }
    initMetadataForClass($, 'StreamingJsonDecoder', VOID, VOID, [JsonDecoder()]);
    StreamingJsonDecoderClass = $;
  }
  return StreamingJsonDecoderClass;
}
var JsonDecoderForUnsignedTypesClass;
function JsonDecoderForUnsignedTypes() {
  if (JsonDecoderForUnsignedTypesClass === VOID) {
    class $ extends AbstractDecoder() {
      constructor(lexer, json) {
        super();
        this.x2u_1 = lexer;
        this.y2u_1 = json.y1r();
      }
      y1r() {
        return this.y2u_1;
      }
      a1s(descriptor) {
        // Inline function 'kotlin.error' call
        var message = 'unsupported';
        throw IllegalStateException().o(toString(message));
      }
      z1q() {
        var tmp0 = this.x2u_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.y2t();
          try {
            // Inline function 'kotlin.UInt.toInt' call
            var this_0 = toUInt(input);
            tmp$ret$0 = _UInt___get_data__impl__f0vqqw(this_0);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.p2s("Failed to parse type '" + 'UInt' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$0;
      }
      a1r() {
        var tmp0 = this.x2u_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.y2t();
          try {
            // Inline function 'kotlin.ULong.toLong' call
            var this_0 = toULong(input);
            tmp$ret$0 = _ULong___get_data__impl__fggpzb(this_0);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.p2s("Failed to parse type '" + 'ULong' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$0;
      }
      x1q() {
        var tmp0 = this.x2u_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.y2t();
          try {
            // Inline function 'kotlin.UByte.toByte' call
            var this_0 = toUByte(input);
            tmp$ret$0 = _UByte___get_data__impl__jof9qr(this_0);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.p2s("Failed to parse type '" + 'UByte' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$0;
      }
      y1q() {
        var tmp0 = this.x2u_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.y2t();
          try {
            // Inline function 'kotlin.UShort.toShort' call
            var this_0 = toUShort(input);
            tmp$ret$0 = _UShort___get_data__impl__g0245(this_0);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.p2s("Failed to parse type '" + 'UShort' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$0;
      }
    }
    initMetadataForClass($, 'JsonDecoderForUnsignedTypes');
    JsonDecoderForUnsignedTypesClass = $;
  }
  return JsonDecoderForUnsignedTypesClass;
}
//region block: exports
export {
  JsonDecoderForUnsignedTypes as JsonDecoderForUnsignedTypesaowwj2t4rf8t,
  StreamingJsonDecoder as StreamingJsonDecoderyo05rsghf9i6,
};
//endregion

//# sourceMappingURL=StreamingJsonDecoder.mjs.map
